import Vue from 'vue'
import Router from 'vue-router'
import { i18n } from './i18n'
import store from './store/'

import Welcome from './views/auth/Welcome'
import WelcomeHero from './components/auth/WelcomeHero'
import Login from './components/auth/Login'
import Register from './components/auth/Register'
import PwReset from './components/auth/PwReset'
import VerifyEmail from './components/auth/VerifyEmail'

import Dashboard from './views/home/Dashboard'

import NetworkGraph from './views/network/Transfers'
import NetworkGraphHome from './components/network/transfers/Home'
import NetworkGraphNetwork from './components/network/transfers/Network'

import AccountProfile from './views/account/AccountProfile'
import AccountProfileHome from './components/account/profile/Home'
import AccountProfileResults from './components/account/profile/Results'

const fb = require('@/firebaseConfig.js')

Vue.use(Router)

function changeLanguage (lang) {
  store.commit('changeLanguage', lang)
}

function changeChain (chain) {
  store.commit('changeChain', chain)
}

// function allowAccess (tier) {
//   let userTier = store.getters.currentUser.userTier
//   if (userTier >= tier) return true
//   else return false
// }

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      component: Welcome,
      children: [
        {
          path: '',
          name: 'welcome',
          component: WelcomeHero
        },
        {
          path: 'login',
          name: 'login',
          component: Login
        },
        {
          path: 'register',
          name: 'register',
          component: Register
        },
        {
          path: 'pwreset',
          name: 'pwreset',
          component: PwReset
        },
        {
          path: 'verify-email',
          name: 'verifyemail',
          component: VerifyEmail,
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      },
      props: true
    },
    {
      path: '/user',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "user" */ './views/user/user'),
      children: [
        {
          path: 'profile',
          name: 'profile',
          component: () => import(/* webpackChunkName: "profile" */ './components/user/profile')
        },
        {
          path: 'settings',
          name: 'settings',
          component: () => import(/* webpackChunkName: "profile" */ './components/user/settings')
        }
      ],
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/network',
      component: NetworkGraph,
      children: [
        {
          path: '',
          name: 'NetworkGraphHome',
          component: NetworkGraphHome
        },
        {
          path: 'transfers',
          name: 'NetworkGraphNetwork',
          component: NetworkGraphNetwork,
          props: true
        }
      ],
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/profile',
      component: AccountProfile,
      children: [
        {
          path: '',
          name: 'AccountProfileHome',
          component: AccountProfileHome
        },
        {
          path: ':account',
          name: 'AccountProfileResults',
          component: AccountProfileResults,
          props: true
        }
      ],
      props: true,
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  // Lang
  let lang = navigator.language.split('-')[0]

  if (localStorage.getItem('language')) {
    lang = localStorage.getItem('language')
  } else {
    if (lang === 'zh' || lang === 'en') {
      localStorage.setItem('language', lang)
    } else {
      lang = 'en'
      localStorage.setItem('language', lang)
    }
  }

  if ((typeof lang !== 'undefined' && lang === 'en') || (typeof lang !== 'undefined' && lang === 'zh')) {
    if (lang !== 'en' && lang !== 'zh') i18n.locale = 'en'
    else i18n.locale = lang
    changeLanguage(lang)
  } else next('/')

  // Chain
  let hostUrl = window.location.host
  let chain = 'eos'

  if (hostUrl.includes('waxdetective')) {
    chain = 'wax'
  } else if (hostUrl.includes('bos')) {
    chain = 'bos'
  }
  changeChain(chain)

  // // Auth
  // const currentUser = fb.auth.currentUser
  // let verifiedEmail = false
  // if (currentUser) verifiedEmail = fb.auth.currentUser.emailVerified
  // const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  try {
    await fb.auth.signInAnonymously()
    if (to.fullPath !== '/') next()
    else next('/network')
  } catch (e) {
    console.log(e)
    try {
      await fb.auth.signInAnonymously()
      if (to.fullPath !== '/') next()
      else next('/network')
    } catch (e) {
      console.log(e)
    }
  }

  // if (requiresAuth && !currentUser) {
  //   setLoginToPath(to.fullPath)
  //   next('/login')
  // } else if (!requiresAuth && currentUser) {
  //   next('/network')
  // } else if (requiresAuth && currentUser && !verifiedEmail && to.name !== 'verifyemail') {
  //   if (currentUser.isAnonymous) {
  //     next()
  //   } else next('/verify-email')
  // } else {
  //   next()
  // }
})

export default router
